import { useNavigate } from 'react-router-dom';

import { Button } from '@flintmint/web-shared/components/button';

import styles from './email-verification.module.scss';

type EmailVerificationProps = {
  logoutPath: string;
};

export const EmailVerification = ({ logoutPath }: EmailVerificationProps) => {
  const navigate = useNavigate();

  const handleSignIn = () => {
    navigate(logoutPath, { replace: true });
  };

  return (
    <div className={styles.emailVerification}>
      <span>
        We've sent a verification link to your email address. Please click the verification link and continue with the sign in. If
        you can't find it, be sure to check your spam folder.
      </span>
      <Button onClick={handleSignIn}>Sign In</Button>
    </div>
  );
};
